var exports = {
  "Rq": "MfaTotpEnableModal.module__qrContainer___VmVLVz",
  "JB": "MfaTotpEnableModal.module__qrCode___VmVLVz",
  "DM": "MfaTotpEnableModal.module__instructionsContainer___VmVLVz",
  "u_": "MfaTotpEnableModal.module__setupDescription___VmVLVz",
  "sO": "MfaTotpEnableModal.module__secretBlock___VmVLVz",
  "tx": "MfaTotpEnableModal.module__secretRow___VmVLVz",
  "iO": "MfaTotpEnableModal.module__secretLabel___VmVLVz",
  "yD": "MfaTotpEnableModal.module__secretText___VmVLVz",
  "iA": "MfaTotpEnableModal.module__buttonIcon___VmVLVz",
};

module.exports = exports;
